import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { withApollo } from "react-apollo";
import { push } from 'connected-react-router';
import { Breadcrumb, Button } from 'antd';
import AntIcon from '../shared/components/AntIcon';
import { Link } from 'react-router-dom';

import CatalogForm from './components/CatalogForm';

import withGraphqlData from '../shared/components/withGraphqlData';
import { parseFormErrors } from '../shared/utils/form_errors';
import { SneakerDetailsQuery, UpdateSneakerMutation } from './queries';

class EditCatalog extends Component {
  constructor(props) {
    super(props);

    this.state = { deleting: false, deleteError: null };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }

  handleSubmit(data) {
    this.setState({ deleteError: null });
    const { client, objectId, push } = this.props;
    return client.mutate({ mutation: UpdateSneakerMutation, variables: { id: objectId, update: data } })
      .then(() => push('/catalog'))
      .catch(parseFormErrors);
  }

  handleDelete() {
    this.setState({ deleting: true, deleteError: null });
    const { client, objectId, push } = this.props;
    return client.mutate({
      mutation: UpdateSneakerMutation,
      variables: { id: objectId, update: { isDeleted: true } },
    })
      .then(() => push('/catalog'))
      .catch(error => this.setState({
        deleting: false, deleteError: error.message,
      }));
  }

  render() {
    const { data } = this.props;
    const { role } = this.props.user;
    const { deleting, deleteError } = this.state;
    const { ModelBrands } = this.props.data;


    const deleteButton = (
      <Button ghost disabled={deleting} loading={deleting} onClick={this.handleDelete} type="danger">
        <AntIcon type="delete" />Delete
      </Button>
    );

    return (
      <div id="edit-catalog">
        <Breadcrumb>
          <Breadcrumb.Item><Link to="/catalog">Catalog</Link></Breadcrumb.Item>
          <Breadcrumb.Item>Edit Catalog</Breadcrumb.Item>
        </Breadcrumb>

        <div className="container">
          <CatalogForm
            initialValues={data.Sneaker}
            onSubmit={this.handleSubmit}
            deleteButton={role === 'admin' && deleteButton}
            deleteError={deleteError}
            brands={ModelBrands}
          />
        </div>
      </div>
    );
  }
}

export default compose(
  withProps(({ match }) => ({
    objectId: match.params.id,
  })),
  withGraphqlData(
    SneakerDetailsQuery,
    (props) => ({ id: props.objectId }),
    'no-cache',
  ),
  connect(({ auth: user }) => ({ user }), { push }),
  withApollo,
)(EditCatalog);
